import { Tooltip } from 'antd';
import { Input, Text } from 'modules/common/components';
import { ComponentProps, FC, useRef, useState } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';

import styles from './styles.module.scss';

type PropTypes = {
  controlled: UseControllerProps<any>;
} & ComponentProps<typeof Input>;

const ControlledInputWithTooltip: FC<PropTypes> = ({
  controlled,
  disabled,
  ...restProps
}) => {
  const { field } = useController(controlled);
  const wrapperRef = useRef<HTMLSpanElement>(null);
  const [isOverflow, setIsOverflow] = useState(false);

  const value = field.value ?? '';

  const checkOverflow = () => {
    const element = wrapperRef.current?.querySelector('input');
    if (element) {
      setIsOverflow(element.scrollWidth > element.clientWidth);
    }
  };

  const input = (
    <Input {...field} {...restProps} disabled={disabled} value={value} />
  );

  if (!disabled) {
    return input;
  }

  return (
    <Tooltip
      title={
        isOverflow ? (
          <Text style={{ color: 'white' }} copyable={{ text: value }}>
            {value}
          </Text>
        ) : null
      }
    >
      <span
        ref={wrapperRef}
        className={styles.InoutWrapper}
        onMouseEnter={checkOverflow}
      >
        {input}
      </span>
    </Tooltip>
  );
};

export default ControlledInputWithTooltip;
